var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-upload-info-container" },
    [
      _c(
        "el-upload",
        {
          class: { uploadContainer: _vm.hideAddDiv },
          attrs: {
            action: _vm.env.VUE_APP_fileserver + "persistentUpload",
            "list-type": "picture-card",
            limit: _vm.limit,
            "file-list": _vm.fileList,
            "on-success": _vm.uploadSuccess,
            "on-remove": _vm.pictureRemove,
            "before-upload": _vm.pictureBeforeUpload
          }
        },
        [_c("i", { staticClass: "el-icon-plus" })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }